import { laravelAxios } from '../../../../config/axios/laravelAxios';
import React, { useEffect, useState } from 'react';
import { SearchCustomer } from 'src/components/common/structure/header/searchCustomer/index.tsx';
import packageJson from '../../../../../package.json';
import {
  logout as logoutAction,
  revokeToken,
} from '../../../../store/modules/auth/actions';
import { toggleChangelog } from '../../../../store/modules/changelog/actions';
import poliConfig from '../../../../utils/poliConfig';
import CreditsCard from 'src/components/credits/available/CreditsCard';
import {
  generateWhatsAppLink,
  generateWhatsAppWebLink,
} from 'src/utils/whatsappLink';

import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Icon,
} from '@polichat/flamboyant';

import { StarsIcon } from 'src/assets/icons/star-icon';

import { AdsLineDark, PhoneLine } from '@poli-digital/react';

import { useLocation, useHistory } from 'react-router-dom';

import DarkMode from '../header/actions/DarkMode';
import Organizations from '../header/actions/Organizations';

import { ChevronRightLine, Out, Search } from '@poli-digital/react';

import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../store/modules/chat/actions';

import SidebarItem from './SidebarItem';
import SidebarMainIcon from './SidebarLogo';

import { useFlags } from 'flagsmith/react';
import { Routers } from '../../../../routes';
import Avatar from '../../profile/Avatar';

import { ToggleNotifications } from '../header/actions/ToggleNotifications';
import { UserStatus } from '../header/actions/UserStatus';
import { LanguageSelector } from '../header/actions/LanguageSelector';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function Sidebar({ config, userConfig, current_customer_id, isMobile }) {
  const routes = Routers();
  const flag = useFlags(['can_view_crm']);
  const { language_selector } = useFlags(['language_selector']);

  const { template_billing } = useFlags(['template_billing']);

  const shouldShowCreditsCard = (() => {
    if (!template_billing) return true;

    let ids = null;

    if (typeof template_billing.value === 'string') {
      try {
        const parsed = JSON.parse(template_billing.value);
        if (Array.isArray(parsed)) {
          ids = parsed.map((id) => String(id).trim());
        }
      } catch (err) {
        return true;
      }
    } else if (Array.isArray(template_billing.value)) {
      ids = template_billing.value.map((id) => String(id).trim());
    }

    if (!ids) return true;

    if (ids.length === 0) return true;

    if (current_customer_id && ids.includes(String(current_customer_id))) {
      return true;
    }

    return false;
  })();

  // Verificar se language_selector está habilitado para este customer
  const canUseLanguageSelector = (() => {
    if (!language_selector || !language_selector.enabled) return false;

    const languageSelectorCustomerIds = (() => {
      if (typeof language_selector.value === 'string') {
        try {
          const parsedValue = JSON.parse(language_selector.value);
          if (Array.isArray(parsedValue) && parsedValue.length > 0) {
            return parsedValue.map((id) => String(id).trim());
          }
        } catch (error) {
          console.error('Erro ao processar language_selector.value:', error);
          return null;
        }
      }
      if (
        Array.isArray(language_selector.value) &&
        language_selector.value.length > 0
      ) {
        return language_selector.value.map((id) => String(id).trim());
      }
      return null;
    })();

    // Se array vazio = liberar para todos, senão verificar se customer está na lista
    return (
      !languageSelectorCustomerIds ||
      languageSelectorCustomerIds.length === 0 ||
      (current_customer_id &&
        languageSelectorCustomerIds.includes(String(current_customer_id)))
    );
  })();

  const [statusUser, setStatusUser] = useState();

  const isAuvo =
    useSelector((state) => state?.whitelabel?.config?.app_title) === 'Auvo';

  const wlState = useSelector((state) => state?.whitelabel);
  const [isWl, setIsWl] = useState();
  const [isWlNotHome, setIsWlNotHome] = useState();
  const [isHelp, setIsHelp] = useState();
  const [isUser, setIsUser] = useState();
  const [loginUrlReseller, setLoginUrlReseller] = useState();

  const flagVersionChangelog = useFlags([
    'version_changelog',
  ]).version_changelog;

  useEffect(() => {
    const _config = wlState?.config;
    const _isWl = _config?.is_white_label;

    const _home = _config?.buttons?.find((e) => e.id === 'home');
    const _help = _config?.buttons?.find((e) => e.id === 'help');
    const _user = _config?.buttons?.find((e) => e.id === 'user');

    setIsWlNotHome(!_home?.id && _isWl);
    setIsHelp(_help?.id);
    setIsUser(_user?.id);
    setLoginUrlReseller(_config?.login_url_reseller);

    setIsWl(_isWl);
  }, [wlState]);

  let avatarOperator;
  let nameOperator;
  let idOperator;
  let currentCustomer;

  const multiCustomers = userConfig?.customers.length > 1 ? true : false;
  const superRole = userConfig?.superRole;
  const dispatch = useDispatch();

  const enableAds =
    poliConfig?.ads_enable ||
    poliConfig?.ads_enable_custumer?.includes(Number(current_customer_id));

  if (!userConfig || userConfig === undefined) {
    avatarOperator = '';
    nameOperator = '';
    idOperator = '';
  } else {
    nameOperator = userConfig.name;
    avatarOperator = userConfig.picture;

    idOperator = userConfig.id;
    currentCustomer = current_customer_id;
  }

  let location = useLocation();

  function isActive(path, subitens) {
    if (path === location.pathname) return true;
    if (!subitens) return false;
    return RegExp(path + '/.+', 'gi').test(location.pathname);
  }

  function isPwa() {
    return localStorage.getItem('pwa');
  }

  const [operatorMenu, setOperatorMenu] = useState(false);
  const [supportMenu, setSupportMenu] = useState(false);
  const [creditsData, setCreditsData] = useState({
    detachedCredits: {
      total: 0,
      used: 0,
    },
    totals: {
      balance: 0,
      used: 0,
    },
    newBillingModel: false,
    groups: {},
  });
  const [creditsMenu, setCreditsMenu] = useState(false);
  const toggle = () => setOperatorMenu((prevState) => !prevState);

  const toggleMenu = () => {
    if (localStorage.getItem('@polichat/menuRetratil') === 'true') {
      document.getElementById('root').classList.add('menuRetratil');
      return true;
    }
    return false;
  };

  // Traduções da sidebar
  const notificationText = useGlotaT('spa.sidebar.notification');
  const supportText = useGlotaT('spa.sidebar.support');
  const suggestionsText = useGlotaT('spa.sidebar.suggestions');
  const helpCenterText = useGlotaT('spa.sidebar.helpCenter');
  const supportEmailText = useGlotaT('spa.sidebar.supportEmail');
  const supportWhatsappText = useGlotaT('spa.sidebar.supportWhatsapp');
  const creditsText = useGlotaT('spa.sidebar.credits');
  const availableCreditsText = useGlotaT('spa.sidebar.availableCredits');
  const collapseMenuText = useGlotaT('spa.sidebar.collapseMenu');
  const newText = useGlotaT('spa.sidebar.new');
  const channelWithoutNameText = useGlotaT('spa.sidebar.channelWithoutName');
  const callsText = useGlotaT('spa.sidebar.calls');
  const massBroadcastText = useGlotaT('spa.sidebar.massBroadcast');
  const wabaAccountText = useGlotaT('spa.sidebar.wabaAccount');
  const whatsappChannelsText = useGlotaT('spa.sidebar.whatsappChannels');

  // Traduções de status
  const availableText = useGlotaT('spa.auth.status.available');
  const disconnectedText = useGlotaT('spa.auth.status.disconnected');
  const unavailableText = useGlotaT('spa.auth.status.unavailable');
  const availableDescText = useGlotaT('spa.auth.status.availableDescription');
  const unavailableDescText = useGlotaT(
    'spa.auth.status.unavailableDescription'
  );

  // Traduções adicionais para JSX
  const themeText = useGlotaT('spa.common.theme');
  const lightText = useGlotaT('spa.common.light');
  const darkText = useGlotaT('spa.common.dark');
  const languageText = useGlotaT('spa.common.language');
  const statusText = useGlotaT('spa.common.status');
  const personalizationText = useGlotaT('spa.common.personalization');
  const companyProfileText = useGlotaT('spa.common.companyProfile');
  const logoutText = useGlotaT('spa.common.logout');
  const aiIncludesText = useGlotaT('spa.tools.aiIncludesTranscripts');
  const ai = useGlotaT('spa.tools.ai');

  // Memoizar enumStatus para evitar recriação
  const enumStatus = React.useMemo(
    () => [
      {
        id: 1,
        name: availableText,
        description: availableDescText,
        color: 'var(--color-success)',
        show: true,
      },
      {
        id: 0,
        name: disconnectedText,
        description: '',
        color: 'var(--danger)',
        show: false,
      },
      {
        id: -1,
        name: unavailableText,
        description: unavailableDescText,
        color: 'var(--color-warning)',
        show: true,
      },
    ],
    [
      availableText,
      disconnectedText,
      unavailableText,
      availableDescText,
      unavailableDescText,
    ]
  );

  const getEnumStatusById = (id) => {
    return enumStatus.find((e) => e.id === id);
  };

  const currentOrganization = userConfig?.customers.find(
    (customer) => customer.id === current_customer_id
  );

  const [menuRetratil, handleMenuRetratil] = useState(toggleMenu());

  const initialChannelData = React.useMemo(
    () => [
      {
        icon: 'poli-icon pi-whatsapp-api-fill',
        label: channelWithoutNameText,
        value: 0,
      },
    ],
    [channelWithoutNameText]
  );

  const [channelData, setChannelData] = useState(initialChannelData);

  const [extraData, setExtraData] = useState([
    {
      id: 'calls',
      icon: 'poli-icon pi-phone-line',
      label: callsText,
      value: 0,
    },
    {
      id: 'massBroadcast',
      icon: <AdsLineDark />,
      label: massBroadcastText,
      value: 0,
    },
    {
      id: 'ai',
      icon: <StarsIcon />,
      label: ai,
      info: aiIncludesText,
      value: 0,
    },
  ]);

  const history = useHistory();

  const handleBuy = () => {
    setCreditsMenu(false);
    history.push('/tools/credit');
  };

  const fetchCreditsData = () => {
    laravelAxios
      .post('/credits/balance')
      .then((res) => {
        const payload = res.data;

        const numericEntries = Object.entries(payload).reduce(
          (acc, [key, value]) => {
            if (!isNaN(Number(key)) && key !== '') {
              acc[key] = value;
            }
            return acc;
          },
          {}
        );

        setChannelData(
          Object.entries(numericEntries)
            .filter(([key, value]) => value?.isWaba)
            .map(([key, value]) => {
              let resValue = (value.active || 0) + (value.template || 0);
              if (!payload.newBillingModel) {
                resValue += value.receptive || 0;
              }
              return {
                icon: value.isWaba
                  ? 'poli-icon pi-whatsapp-api-fill'
                  : 'poli-icon pi-whatsapp-line',
                label: value.channelName,
                value: resValue || 0,
              };
            })
        );

        const groupedByGroupId = {};
        Object.entries(numericEntries).forEach(([key, value]) => {
          if (value?.groupId) {
            const gId = String(value.groupId);
            if (!groupedByGroupId[gId]) {
              groupedByGroupId[gId] = {
                groupId: gId,
                groupTotal: payload.wabaExpenditureGroups?.[gId]?.total || 0,
                groupUsed:
                  payload.wabaExpenditureGroups?.[gId]?.usedMessage || 0,
                channels: [],
                wabaName:
                  payload.wabaExpenditureGroups?.[gId]?.wabaName ||
                  wabaAccountText,
              };
            }
            groupedByGroupId[gId].channels.push({
              icon: value.isWaba
                ? 'poli-icon pi-whatsapp-api-fill'
                : 'poli-icon pi-whatsapp-line',
              label: value.channelName,
              value: value.usedMessage || 0,
            });
          }
        });

        setExtraData((prevExtraData) => [
          { ...prevExtraData[0], value: payload.totals.call || 0 },
          { ...prevExtraData[1], value: payload.totals.trigger || 0 },
          {
            ...prevExtraData[2],
            value:
              payload.totals.audioTranscription +
                payload.totals.summary +
                payload.totals.suggestion +
                payload.totals.improveMessage || 0,
          },
        ]);

        setCreditsData({
          ...payload,
          groups: groupedByGroupId,
        });
      })
      .catch(() =>
        setCreditsData({
          totals: { balance: 0, used: 0 },
          newBillingModel: true,
          groups: {},
        })
      );
  };

  const handleCreditsToggle = () => {
    setCreditsMenu((prev) => {
      const nowOpen = !prev;
      if (nowOpen) {
        fetchCreditsData();
      }
      return nowOpen;
    });
  };

  function handleMenu() {
    const rootElement = document.getElementById('root');
    if (rootElement.classList.contains('menuRetratil')) {
      handleMenuRetratil(false);
      rootElement.classList.remove('menuRetratil');
      localStorage.removeItem('@polichat/menuRetratil');
    } else {
      handleMenuRetratil(true);
      rootElement.classList.add('menuRetratil');
      localStorage.setItem('@polichat/menuRetratil', true);
    }
  }

  async function logout() {
    dispatch(logoutAction());
    dispatch(revokeToken());
    window.location.href = '/login';
  }

  function myAccount() {
    if (isWl && loginUrlReseller?.toString()?.length > 2) {
      window.location.href = loginUrlReseller;
    } else {
      window.location.href = `${poliConfig.poliAppLaravelUrl}/users/${currentCustomer}/${idOperator}/edit`;
    }
  }

  function handleVersionChangelog() {
    if (flagVersionChangelog.enabled) {
      dispatch(toggleChangelog());
    }
  }

  function cutName(name) {
    const arrName = name?.split(' ');
    const removeShortName = arrName?.filter((value) => {
      if (value.length > 2) {
        return value;
      }
    });
    if (removeShortName?.length != 0 && removeShortName?.length >= 2) {
      return `${removeShortName[0]} ${removeShortName[1]}`;
    }
    return name;
  }

  return (
    <>
      <SidebarMainIcon />
      <ul className="sidebarMenu">
        {superRole === 'adm' && (
          <div className="showMenuRetratil menuRetratilTop">
            {menuRetratil ? (
              <div onClick={handleMenu}>
                <Search />
              </div>
            ) : (
              <SearchCustomer />
            )}
          </div>
        )}
        {routes.map((route, index) => {
          let active = isActive(route.path, route.subitens);

          let show = true;
          let path = route.path;

          if (isPwa()) {
            show = route.showPwa;
            if (route.path === '/') {
              path = '/chat';
            }
          }

          if (
            route.isNew &&
            !flag.can_view_crm?.value?.includes(current_customer_id)
          ) {
            route.showIsNew = true;
            path = generateWhatsAppLink('spa.common.whatsapp.wantToKnowCRM');
          }

          if (isWlNotHome) {
            if (route.path === '/') {
              path = '/chat';
            }
          }

          if (!enableAds && path === '/ads') {
            return <></>;
          }

          if (route.sidebarName && show) {
            return (route.needAdmin && superRole === 'adm') ||
              !route.needAdmin ? (
              <React.Fragment key={`route-${index}`}>
                <li>
                  <SidebarItem
                    key={index}
                    name={route.sidebarName}
                    url={path}
                    icon={route.icon}
                    active={active}
                    title={route.title}
                    openNewPage={
                      route?.openNewPage || route?.openNewPage === false
                        ? route.openNewPage
                        : null
                    }
                  />
                </li>
                {route.showIsNew && (
                  <div className="newFunctionality">
                    <span>{newText}</span>
                  </div>
                )}
              </React.Fragment>
            ) : null;
          }
        })}
      </ul>

      <div className="sidebarUserConfig">
        <div>
          {isHelp && (
            <>
              <div className="supportMenu sidebarMenuItem">
                <Button color={'link'} className="notification">
                  <Icon icon="poli-icon pi-bell-fill" />
                  <span>{notificationText}</span>
                </Button>
              </div>

              <div className="supportMenu sidebarMenuItem">
                <Dropdown
                  direction="right"
                  isOpen={supportMenu}
                  toggle={() => setSupportMenu((prevState) => !prevState)}
                >
                  <DropdownToggle color={'link'} className="supportMenuButton">
                    <Icon icon="poli-icon pi-question-fill" />
                    <span>{supportText}</span>
                  </DropdownToggle>
                  <DropdownMenu className="menuDropdownShow">
                    <DropdownItem
                      className="itemDropdownMenu"
                      onClick={() =>
                        window.open('https://forms.gle/f8FGaGFENdgUbo9r9')
                      }
                    >
                      <Icon
                        icon={'poli-icon pi-alerts-line'}
                        color={'var(--green-polichat)'}
                        size={25}
                        position={'relative'}
                        left={'2px'}
                      />
                      <p className="alternative">{suggestionsText}</p>
                      <Icon
                        icon={'poli-icon pi-simple-arrow-right-line'}
                        position={'relative'}
                        size={15}
                      />
                    </DropdownItem>

                    <DropdownItem
                      className="itemDropdownMenu"
                      onClick={() =>
                        window.open('https://poli.digital/central-de-ajuda/')
                      }
                    >
                      <Icon
                        icon={'poli-icon pi-info-line'}
                        color={'var(--green-polichat)'}
                        size={24}
                      />
                      <p className="alternative">{helpCenterText}</p>
                      <Icon
                        icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                        position={'relative'}
                        size={15}
                      />
                    </DropdownItem>

                    <DropdownItem
                      className="itemDropdownMenu"
                      onClick={() =>
                        window.open('mailto:contato@polichat.com.br')
                      }
                    >
                      <Icon
                        icon={'poli-icon pi-mail-line'}
                        color={'var(--green-polichat)'}
                        size={24}
                      />
                      <p className="alternative">{supportEmailText}</p>
                      <Icon
                        icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                        size={15}
                      />
                    </DropdownItem>

                    <DropdownItem
                      className="itemDropdownMenu"
                      onClick={() => {
                        window.open(
                          generateWhatsAppWebLink(
                            'spa.common.whatsapp.wantToKnowCRM'
                          )
                        );
                      }}
                    >
                      <Icon
                        icon={'poli-icon pi-whatsapp-line'}
                        color={'var(--green-polichat)'}
                        size={24}
                      />
                      <p className="alternative">{supportWhatsappText}</p>
                      <Icon
                        icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                        size={15}
                      />
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>

              {shouldShowCreditsCard ? (
                <div className="supportMenu sidebarMenuItem">
                  <div className="creditsMenu">
                    <Dropdown
                      direction="right"
                      isOpen={creditsMenu}
                      toggle={handleCreditsToggle}
                    >
                      <div className="credits-container">
                        <DropdownToggle
                          color="invisible"
                          className="credits-toggle"
                          style={(() => {
                            const value = creditsData.newBillingModel
                              ? Math.max(
                                  0,
                                  (creditsData.detachedCredits?.total || 0) -
                                    (creditsData.totals?.used || 0)
                                )
                              : Math.max(
                                  0,
                                  (creditsData.detachedCredits?.total || 0) -
                                    (creditsData.totals?.trigger +
                                      creditsData.totals?.call +
                                      creditsData.totals?.audioTranscription +
                                      creditsData.totals?.summary +
                                      creditsData.totals?.suggestion +
                                      creditsData.totals?.improveMessage +
                                      creditsData.detachedCredits?.used || 0)
                                );

                            const digits = String(value).replace(
                              /\D/g,
                              ''
                            ).length;

                            return {
                              minWidth: '210px',
                              justifyContent: 'flex-start',
                              padding: digits > 3 ? '5px 10px' : '12px 12px',
                              display: 'flex',
                              alignItems: 'center',
                            };
                          })()}
                        >
                          <Icon
                            icon="poli-icon pi-pay-fill"
                            className="credits-icon"
                          />
                          <span className="credits-label" style={{ flex: 1 }}>
                            {availableCreditsText}
                            {(() => {
                              const value = creditsData.newBillingModel
                                ? Math.max(
                                    0,
                                    (creditsData.detachedCredits?.total || 0) -
                                      (creditsData.totals?.used || 0)
                                  )
                                : Math.max(
                                    0,
                                    (creditsData.detachedCredits?.total || 0) -
                                      (creditsData.totals?.trigger +
                                        creditsData.totals?.call +
                                        creditsData.totals?.audioTranscription +
                                        creditsData.totals?.summary +
                                        creditsData.totals?.suggestion +
                                        creditsData.totals?.improveMessage +
                                        creditsData.detachedCredits?.used || 0)
                                  );

                              const digits = String(value).replace(
                                /\D/g,
                                ''
                              ).length;

                              if (digits > 3) {
                                return (
                                  <>
                                    <br />
                                    <strong className="credits-value credits-break">
                                      {value.toLocaleString('pt-BR')}
                                    </strong>
                                  </>
                                );
                              }

                              return (
                                <>
                                  :&nbsp;
                                  <strong className="credits-value">
                                    {value.toLocaleString('pt-BR')}
                                  </strong>
                                </>
                              );
                            })()}
                          </span>
                        </DropdownToggle>
                      </div>
                      <DropdownMenu className="menuDropdownShow container__credits--menu">
                        <CreditsCard
                          billingAi={creditsData.billingAi}
                          availableCredits={creditsData.totals.balance}
                          consumedCredits={creditsData.totals.used}
                          totalCredits={
                            creditsData.newBillingModel
                              ? creditsData.detachedCredits?.total
                              : creditsData.totals.balance
                          }
                          channelTitle={whatsappChannelsText}
                          channels={channelData}
                          extras={extraData}
                          onBuy={handleBuy}
                          newBillingModel={creditsData.newBillingModel}
                          detachedCreditsTotal={
                            creditsData.detachedCredits?.total
                          }
                          detachedCreditsUsed={
                            creditsData.detachedCredits?.usedMessage
                          }
                          groups={creditsData.groups}
                          oldSumTypeBillingModel={
                            creditsData.totals.trigger +
                            creditsData.totals.call +
                            creditsData.totals.audioTranscription +
                            creditsData.totals.summary +
                            creditsData.totals.suggestion +
                            creditsData.totals.improveMessage
                          }
                        />
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              ) : (
                <div className="supportMenu sidebarMenuItem">
                  <Button
                    color={'link'}
                    className="notification"
                    onClick={() => {
                      history.push('/relatorio');

                      const sidebar = document.querySelector('.sidebarMenu');
                      if (sidebar) {
                        sidebar.scrollTo({
                          top: sidebar.scrollHeight,
                          behavior: 'smooth',
                        });
                      }
                    }}
                  >
                    <Icon icon="poli-icon pi-pay-fill" />
                    <span>{creditsText}</span>
                  </Button>
                </div>
              )}
            </>
          )}

          {isUser && !isAuvo && (
            <div className="operatorMenu" id={idOperator}>
              <Dropdown direction="right" isOpen={operatorMenu} toggle={toggle}>
                <DropdownToggle color={'insivible'}>
                  <Avatar
                    className="operator"
                    title={nameOperator}
                    url={avatarOperator}
                    extraClass="avatarSidebar"
                    size={30}
                  />
                  <p className="operatorName">{cutName(nameOperator)}</p>
                </DropdownToggle>
                <div
                  className="statusUserIconNav miniStatusUser"
                  style={{
                    backgroundColor: getEnumStatusById(statusUser)?.color,
                    border: '3px solid var(--primary-background-color)',
                  }}
                />
                <DropdownMenu className="menuDropdownShow container__operator--menu">
                  <>
                    <div>
                      <div className="userTitleName">
                        <h3>{cutName(config?.user?.name ?? '')}</h3>
                        <div onClick={myAccount} style={{ cursor: 'pointer' }}>
                          <Icon
                            icon={'poli-icon pi-pencil-fill'}
                            size={30}
                            color={'var(--activated-icons-color)'}
                          />
                        </div>
                      </div>
                      <span className="userCustomer">
                        {currentOrganization?.name}
                      </span>
                    </div>
                    <span className="userTitle">{themeText}</span>
                    <div className="themeDiv">
                      {lightText}
                      <DarkMode />
                      {darkText}
                    </div>
                    <hr />
                    {canUseLanguageSelector && (
                      <>
                        <span className="userTitle">{languageText}</span>
                        <LanguageSelector />
                        <hr />
                      </>
                    )}
                    <span className="userTitle">{statusText}</span>
                    <UserStatus miniStatusUser={setStatusUser} />
                    <hr />
                    <div>
                      <span className="userTitle">{personalizationText}</span>
                      <ToggleNotifications />
                    </div>
                    <hr />
                    <span className="userTitle">{companyProfileText}</span>
                    <Organizations />
                    <hr style={{ margin: '5px 0px 16px 0px' }} />
                  </>
                  <div className="mobileTopActions">
                    {multiCustomers && (
                      <>
                        <Organizations />
                        <br />
                      </>
                    )}
                    <DarkMode />
                  </div>
                  {!isWl && (
                    <DropdownItem
                      className="itemDropdownMenu operatorExitPolichat"
                      onClick={logout}
                    >
                      <Out width={16} height={16} />
                      <p className="alternative">{logoutText}</p>
                      <ChevronRightLine width={16} height={16} />
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>
          )}

          <div
            id="retratilButton"
            className="showMenuRetratil menuRetratilClass"
            onClick={handleMenu}
          >
            {menuRetratil ? (
              <Icon
                position={'relative'}
                top={'2px'}
                left={'-3px'}
                icon={'poli-icon poli-icon pi-next-fill'}
              />
            ) : (
              <Icon
                position={'relative'}
                top={'-2px'}
                icon={'poli-icon poli-icon pi-previous-fill'}
              />
            )}
            <span>{collapseMenuText}</span>
          </div>

          <div className="showVersion" onClick={() => handleVersionChangelog()}>
            <span className="numberVersion">{packageJson?.version}</span>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state, ownProps) => ({
  config: state.chat.config,
  userConfig: state?.general?.user,
  props: ownProps,
  current_customer_id: state.general?.current_customer_id,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
